// Gestión centralizada del tema (claro/oscuro/sistema) para toda la app.
//
// Preferencia guardada en localStorage('theme'): "light" | "dark" | "system".
// Se aplica como atributo data-theme en <html> (DaisyUI). En modo "system" se
// resuelve con prefers-color-scheme y se actualiza EN VIVO si el usuario cambia
// el tema del dispositivo.

const KEY = "theme";
const mql = () => window.matchMedia("(prefers-color-scheme: dark)");

export function getStoredTheme() {
  return localStorage.getItem(KEY) || "system";
}

// Devuelve el tema concreto a pintar ("dark" | "light") resolviendo "system".
export function resolvedTheme(pref = getStoredTheme()) {
  if (pref === "system") return mql().matches ? "dark" : "light";
  return pref === "dark" ? "dark" : "light";
}

// Aplica y persiste la preferencia.
export function applyTheme(pref) {
  localStorage.setItem(KEY, pref);
  document.documentElement.setAttribute("data-theme", resolvedTheme(pref));
}

let inited = false;

// Llamar una vez al arrancar la app: aplica el tema guardado y deja escuchando
// los cambios del tema del sistema (solo afectan cuando la preferencia es "system").
export function initTheme() {
  if (inited) return;
  inited = true;
  applyTheme(getStoredTheme());
  mql().addEventListener("change", () => {
    if (getStoredTheme() === "system") {
      document.documentElement.setAttribute("data-theme", resolvedTheme("system"));
    }
  });
}
